$(document).on('ready turbolinks:load', () => {});
